import { DialogFooter } from './DialogFooter';

// TODO: in v9, move styled() from DialogFooter.jsx to here
export var StyledDialogFooter = DialogFooter;